import { Injectable, Output, EventEmitter } from '@angular/core';
import { CalendarEventModel, CopyGroupClassesScheduleMethod, CopyGroupClassMethod } from '@bayclubs/group-classes-employee-api';

@Injectable({
    providedIn: 'root'
})
export class CalendarEventsService {
    constructor() {}

    @Output() public copySchedule$: EventEmitter<CopyGroupClassesScheduleMethod> = new EventEmitter<
        CopyGroupClassesScheduleMethod
    >();

    @Output() public copySingle$: EventEmitter<any> = new EventEmitter<any>();

    @Output() public editEvent$: EventEmitter<CalendarEventModel> = new EventEmitter<CalendarEventModel>();

    @Output() public cancelEvent$: EventEmitter<any> = new EventEmitter<any>();

    @Output()
    public restoreEvent$: EventEmitter<{id: string, hasAlreadyStarted: boolean}>
        = new EventEmitter<{id: string, hasAlreadyStarted: boolean}>();

    @Output() public removeEvent$: EventEmitter<CalendarEventModel> = new EventEmitter<CalendarEventModel>();

    @Output() public subRequestEvent$ = new EventEmitter<CalendarEventModel>();

    @Output() public substituteInstructor$: EventEmitter<CalendarEventModel> = new EventEmitter<
        CalendarEventModel
    >();

    @Output() public cancelSubstitution$: EventEmitter<any> = new EventEmitter<CalendarEventModel>();

    public onCopySchedule(method: CopyGroupClassesScheduleMethod): void {
        this.copySchedule$.emit(method);
    }

    public onCopySingle(groupClassId, method: CopyGroupClassMethod, instructorId: string): void {
        this.copySingle$.emit({
            groupClassId: groupClassId,
            method: method,
            instructorId: instructorId
        });
    }

    public onEditEvent(event: CalendarEventModel): void {
        this.editEvent$.emit(event);
    }

    public onCancelEvent(event: CalendarEventModel): void {
        this.cancelEvent$.emit(event);
    }

    public onRestoreEvent(eventId: string, hasAlreadyStarted: boolean): void {
        this.restoreEvent$.emit({hasAlreadyStarted: hasAlreadyStarted, id: eventId });
    }

    public onRemoveEvent(event: CalendarEventModel): void {
        this.removeEvent$.emit(event);
    }

    public onSubRequestEvent(event: CalendarEventModel): void {
        this.subRequestEvent$.emit(event);
    }

    public onSubstituteInstructor(event: CalendarEventModel): void {
        this.substituteInstructor$.emit(event);
    }

    public onCancelSubstitution(eventId): void {
        this.cancelSubstitution$.emit(eventId);
    }
}
